import React from 'react';

const SearchItemLoader = () => {
    return (
        <div className="animate-pulse text-md font-normal text-gray-600 grid grid-cols-9 content-center justify-center gap-x-2  py-2 border-b">
            <div className='md:block hidden'>
                <div className='w-full col-span-1 grid justify-center'>
                    <p className='bg-slate-200 text-slate-200'>Loading...</p>
                </div>
            </div>
            <div className='md:px-2 px-0 h-full col-span-4 md:mb-0 mb-3'>
                <div className='h-full grid content-center'>
                    <p className='bg-slate-200 text-slate-200'>Loading...</p>

                </div>
            </div>
            <div className='md:flex flex-none md:pt-3 col-span-4 grid content-center md:space-x-2 space-x-0'>
                <div className='w-full flex justify-end gap-x-2'>
                    <p className='line-through whitespace-nowrap bg-slate-200 text-slate-200'>Loading...</p>
                    <p className='whitespace-nowrap bg-slate-200 text-slate-200'>Loaading...</p>
                </div>
            </div>
        </div>
    );
};

export default SearchItemLoader;